import React, { useContext } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faInfoCircle,
  faPen,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import { APIContext } from "../../api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert, Radio, RadioGroup } from "@chakra-ui/react";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  Input,
  Box,
} from "@chakra-ui/react";
import { PLANS } from "../../plans";
import UserAddons from "../../components/user-addons";

function AdminChangePlanAddons({
  subscription,
  userAttributes,
  open,
  setOpen,
  setAccountDetails,
}) {
  const {
    getUserAttribute,
    updateUserAttributes,
    getUserEmailVerify,
    userAccountDisable,
    userAccountEnable,
    userDelete,
    resetUserPassword,
    adminActions,
  } = useContext(APIContext);
  const [newPasswordParams, setNewPasswordParams] = React.useState({});
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  const [isUpdatingPlan, setIsUpdatingPlan] = React.useState(false);

  const [newSubscriptionParams, setNewSubscriptionParams] = React.useState({
    plan: subscription?.plan ?? "free",
  });

  const navigate = useNavigate();

  return (
    <>
      <Modal
        blockScrollOnMount={false}
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        size="xl"
        borderRadius="21px"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody
            mx="10px"
            my="30px"
            p="10px"
            borderRadius="20px"
          >
            <UserAddons userSub={userAttributes.sub} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AdminChangePlanAddons;
